import { required,
  email as _email, minLength as _minLength, maxLength as _maxLength
} from 'vuelidate/lib/validators';

import {
  MIN_LENGTH_STRING,
  MAX_LENGTH_STRING,
  singleRuStringformat,
  notSpaceInBeginningStringformat,
  validateUrl,
  validateUrlWithUrlPath,
  validatePhone } from '@/utils/input_utils';

const minLength = _minLength(MIN_LENGTH_STRING);
const maxLength = _maxLength(MAX_LENGTH_STRING);

export const website = {
  minLength,
  maxLength,
  validateUrl,
  validateUrlWithUrlPath
};

export const postalAddress = {
  required,
  minLength: _minLength(12),
  maxLength,
  notSpaceInBeginningStringformat
};

export const email = {
  required,
  _email
};

export const phone = {
  required,
  validatePhone
};

export const firstName = {
  required,
  minLength,
  maxLength,
  singleRuStringformat
};

export const middleName = {
  minLength,
  maxLength,
  singleRuStringformat
};

export const lastName = {
  required,
  minLength,
  maxLength,
  singleRuStringformat
};
